import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { toast as toastify, ToastOptions } from "react-toastify";
import "./Toastify.scss";

export enum ToastType {
  Warning,
  Error,
  Info,
  Success,
}

export const CloseButton = ({ closeToast }) => (
  <HighlightOffIcon className="Toastify__close-btn" onClick={closeToast} />
);

const Toastify = {
  error: (
    message: string,
    title?: string,
    options?: ToastOptions | undefined
  ) => {
    toastify.error(
      <>
        {title && <div className="Toastify__toast-body__title">{title}</div>}
        {message}
      </>,
      { ...options }
    );
  },
  success: (
    message: string,
    title?: string,
    options?: ToastOptions | undefined
  ) => {
    toastify.success(
      <>
        {title && <div className="Toastify__toast-body__title">{title}</div>}
        {message}
      </>,
      { ...options, icon: <CheckCircleOutlineIcon /> }
    );
  },
  warn: (
    message: string,
    title?: string,
    options?: ToastOptions | undefined
  ) => {
    toastify.warn(
      <>
        {title && <div className="Toastify__toast-body__title">{title}</div>}
        {message}
      </>,
      { ...options }
    );
  },
  info: (
    message: string,
    title?: string,
    options?: ToastOptions | undefined
  ) => {
    toastify.info(
      <>
        {title && <div className="Toastify__toast-body__title">{title}</div>}
        {message}
      </>,
      { ...options }
    );
  },
};

export default Toastify;
